import { useState } from "react";
import { useProjectTypes, useSetProjectTypeVisibility } from "features/ProjectType/data/hooks";
import { PAGE_SIZE_DEFAULT } from "features/ProjectType/core";
import { confirmHide, showProjectTypeError } from "features/ProjectType/presentation/components/ProjectTypeState";
export default function useProjectTypeList() {
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const query = useProjectTypes({ keyword, page, size: PAGE_SIZE_DEFAULT });
  const mutation = useSetProjectTypeVisibility();
  const onSaved = async (record) => {
    query.setData((value) =>
      value ? { ...value, items: value.items.map((item) => (item.id === record.id ? record : item)) } : value
    );
    await query.refetch();
  };
  const changeVisibility = (record, visible) => {
    const save = async () => {
      try {
        await onSaved(await mutation.mutate(record.id, visible));
      } catch (error) {
        showProjectTypeError(error);
      }
    };
    if (visible) save();
    else confirmHide(save);
  };
  return {
    ...query,
    error: mutation.error?.code === "FORBIDDEN" ? mutation.error : query.error,
    keyword,
    setKeyword: (value) => {
      setKeyword(value);
      setPage(1);
    },
    page,
    setPage,
    modalOpen,
    setModalOpen,
    changeVisibility,
    saving: mutation.loading,
    onSaved,
  };
}
